import React, {useContext} from 'react';
import {observer} from 'mobx-react-lite';
import { StoreContext } from '../base/root-store';
import {IntegrationConfigModal} from './IntegrationConfigModal';

export const WemplyConfigModal = observer((): JSX.Element => {
    const store = useContext(StoreContext).companyStore;

    return (
        <IntegrationConfigModal
            initialSettings={store.payload!.wemplyConfig}
            titleLabel={store.label('company.wemply-config.title')}
            apiKeyLabel={store.label('company.wemply-config.api-key.label')}
            authKeyId="wemply-auth-key"
            disconnectLabel={store.label('company.wemply-config.disconnect')}
            disconnectConfirmLabel={store.label('company.wemply-config.disconnect-confirm')}
            saveConfig={(config): void => store.saveWemplyConfig(config)}
            revokeConfig={async (): Promise<void> => store.revokeWemplyConfig()}
        />
    );
});
